import React from 'react';
import { Box, Typography, Divider, Chip } from '@mui/material';
import CloudIcon from '@material-ui/icons/Cloud';

interface CloudProviderSectionProps {
  title: string;
  children: React.ReactNode;
  configCount: number;
  color?: string;
}

export const CloudProviderSection: React.FC<CloudProviderSectionProps> = ({
  title,
  children,
  configCount,
  color = '#1976d2',
}) => {
  if (configCount === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      {/* Cloud Provider Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2,
          p: 2,
          backgroundColor: `${color}08`,
          borderRadius: 1,
          borderLeft: `4px solid ${color}`,
        }}
      >
        <CloudIcon style={{ marginRight: 8, color }} />
        <Typography
          variant="h5"
          sx={{ flexGrow: 1, color, fontWeight: 'bold' }}
        >
          {title}
        </Typography>
        <Chip
          label={`${configCount} config${configCount > 1 ? 's' : ''}`}
          size="small"
          sx={{
            backgroundColor: color,
            color: 'white',
            fontWeight: 'bold',
          }}
        />
      </Box>

      {/* Cloud Provider Content */}
      <Box sx={{ pl: 2 }}>{children}</Box>

      {/* Divider */}
      <Divider sx={{ mt: 3, mb: 1 }} />
    </Box>
  );
};
